export default "__VITE_ASSET__CNc6npsX__"